import type { AxiosError } from 'axios'

const DEFAULT_API_ERROR_MESSAGE = 'خطای سرور'

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null
}

function messageFromErrorEntry(entry: unknown): string | null {
  if (typeof entry === 'string' && entry.trim()) {
    return entry.trim()
  }

  if (!isRecord(entry)) {
    return null
  }

  if (typeof entry.message === 'string' && entry.message.trim()) {
    return entry.message.trim()
  }

  const firstStringValue = Object.values(entry).find(
    (value) => typeof value === 'string' && value.trim()
  )

  return typeof firstStringValue === 'string' ? firstStringValue.trim() : null
}

export function extractApiErrorMessages(
  data: unknown,
  fallback = DEFAULT_API_ERROR_MESSAGE
): string[] {
  if (!isRecord(data)) {
    return [fallback]
  }

  const errors = data.errors

  if (Array.isArray(errors) && errors.length > 0) {
    const messages = errors
      .map(messageFromErrorEntry)
      .filter((message): message is string => Boolean(message))

    if (messages.length > 0) {
      return messages
    }
  }

  if (typeof data.message === 'string' && data.message.trim()) {
    return [data.message.trim()]
  }

  if (typeof data.title === 'string' && data.title.trim()) {
    return [data.title.trim()]
  }

  return [fallback]
}

export function getAxiosErrorMessage(
  error: unknown,
  fallback = DEFAULT_API_ERROR_MESSAGE
): string {
  const axiosError = error as AxiosCustomError

  if (axiosError.response?.data) {
    return extractApiErrorMessages(axiosError.response.data, fallback).join(' ')
  }

  if (error instanceof Error && error.message) {
    return error.message
  }

  return fallback
}

export function isAxiosError(error: unknown): error is AxiosCustomError {
  return Boolean((error as AxiosError)?.isAxiosError)
}
